// Top 100 Dutch cities/municipalities by population
export const CITIES = [
  "Amsterdam", "Rotterdam", "Den Haag", "Utrecht", "Eindhoven", "Groningen",
  "Tilburg", "Almere", "Breda", "Nijmegen", "Enschede", "Haarlem",
  "Arnhem", "Zaanstad", "Amersfoort", "Apeldoorn", "s-Hertogenbosch",
  "Hoofddorp", "Maastricht", "Leiden", "Dordrecht", "Zoetermeer",
  "Zwolle", "Deventer", "Delft", "Alkmaar", "Leeuwarden", "Venlo",
  "Amstelveen", "Emmen", "Sittard", "Ede", "Nissewaard", "Westland",
  "Roosendaal", "Purmerend", "Oss", "Hilversum", "Heerlen", "Vlaardingen",
  "Gouda", "Almelo", "Assen", "Bergen op Zoom", "Capelle aan den IJssel",
  "Veenendaal", "Katwijk", "Nieuwegein", "Lelystad", "Hengelo",
  "Zeist", "Roermond", "Schiedam", "Spijkenisse", "Barneveld",
  "Ridderkerk", "Terneuzen", "Meppel", "Wageningen", "Beverwijk",
  "Weert", "Waalwijk", "Doetinchem", "Kampen", "Middelburg", "Rijswijk",
  "Woerden", "Houten", "IJsselstein", "Gorinchem", "Zutphen", "Culemborg",
  "Papendrecht", "Sneek", "Harderwijk", "Bussum", "Naarden", "Huizen",
  "Laren", "Blaricum", "Muiden", "Weesp", "Baarn", "Soest", "Bunschoten",
  "Nunspeet", "Ermelo", "Putten", "Hardenberg", "Coevorden", "Emmeloord",
  "Steenwijk", "Winschoten", "Heerenveen", "Drachten", "Franeker",
  "Bolsward", "Wolvega", "Uithoorn", "Aalsmeer", "Diemen", "Duiven",
];

export const citySlug = (c) =>
  c.toLowerCase().replace(/\s/g, "-").replace(/'/g, "").replace(/^s-/, "s-");

export const cityName = (slug) => {
  const found = CITIES.find((c) => citySlug(c) === slug);
  return found || slug;
};
